export default __webpack_public_path__ + "static/media/consorcioLogo.5ae64f34.svg";